import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { gqlClient } from 'src/client/gql-client';

type Options<T> = UseQueryOptions<T> & {
  queryKey: any[];
  query: string;
  variables?: Record<string, any>;
};

export function useGqlQuery<T>(options: Options<T>) {
  const { queryKey, query, variables = {}, ...rest } = options;

  const result = useQuery<T>({
    ...rest,
    queryKey: options.queryKey.concat([variables]),
    queryFn: () => gqlClient.request<T>(query, variables),
  });

  return result;
}
